import { ApiException, CreateUserDTO, RegisterUserResultDTO, RegisterUserResultStatusCode, UserAccountClient } from 'src/app/base/models/models.swagger.generated';
import { Injectable } from '@angular/core';
import { SpinnerService } from '../spinner/spinner.service';
import { catchError, Observable, tap } from 'rxjs';
import { ToastService } from '../services/toast.service';

@Injectable({
  providedIn: 'root'
})
export class RegisterService {

  constructor(
    private userAccountClient: UserAccountClient,
    private spinnerService: SpinnerService,
    private toastService: ToastService
  ) { }

  registerUser(userData: CreateUserDTO): Observable<RegisterUserResultDTO> {
    this.spinnerService.show();
    return this.userAccountClient.registerUser(userData).pipe(tap({
      next: (result: RegisterUserResultDTO) => {
        this.spinnerService.hide();
        if (result.statusCode != RegisterUserResultStatusCode.Success ) {
          this.toastService.showError(
            'i18n.errors.server-error.title',
            'i18n.errors.server-error.message',
            null,
            null,
            result.errorText
          );
          throw new Error('Registration failed');
        }
      },
      error: (error: ApiException) => {
        this.spinnerService.hide();
        this.toastService.showApiExeption(error, 'i18n.errors.server-error.title', 'i18n.errors.server-error.message');
      }
    }),
    catchError((error) => {
      this.spinnerService.hide();
      throw error;
    }));
  }
}
